<template>
  <div class="contractAdd">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-title">住户信息</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <span class="line-text">住户名称：</span>
          </div>
          <div class="line-info">{{formData.enterpriseName || '无'}}</div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">退租合同编号：</span>
          </div>
          <div class="line-info">{{formData.code || '无'}}</div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">退租日期：</span>
          </div>
          <div class="line-info">{{surrenderDate || '无'}}</div>
        </div>
      </div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <span class="line-text">退租房源：</span>
          </div>
          <div class="line-info">{{formData.roomInfoName || '无'}}</div>
        </div>
        <div v-if="!isHousingInUnion">
          <div class="textBox">
            <span class="line-text">租赁面积：</span>
          </div>
          <div class="line-info" v-if="formData.roomInfoArea">{{formData.roomInfoArea}}m²</div>
          <div class="line-info" v-else>无</div>
        </div>
        <div v-if="isHousingInUnion">
          <div class="textBox">
            <span class="line-text">租赁工位：</span>
          </div>
          <div class="line-info" v-if="formData.officeSeat">{{formData.officeSeat}}m²</div>
          <div class="line-info" v-else>无</div>
        </div>
      </div>

      <div class="form-title" style="display: flex;justify-content: space-between;padding-right: 140px">
        <span>账单信息</span>
        <div>
          <span style="margin-left: 20px;color: #00A0E6;cursor: pointer;font-size: 14px;margin-right: 20px;" @click="historyBill"><i class="el-icon-damai-jiaofeijilu"></i>查看历史账单</span>
          <span v-if="sumMoney >= 0" style="font-size: 14px"><span style="color: #00A0E6">应收: </span>{{sumMoney}} 元</span>
          <span v-if="sumMoney < 0" style="font-size: 14px"><span style="color: #f25721">应退: </span>{{Math.abs(sumMoney)}} 元</span>
        </div>
      </div>
      <div class="form-line-title">保证金信息</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <span class="line-text">费用类型：</span>
          </div>
          <div class="line-info">{{rentMarginInformation.itemName || '无'}}</div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">金额：</span>
          </div>
          <div class="line-info" v-if="rentMarginInformation.retreat === '1'">应收{{rentMarginInformation.itemMoney || '0'}}元</div>
          <div class="line-info" v-if="rentMarginInformation.retreat === '2'">应退{{rentMarginInformation.itemMoney || '0'}}元</div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">备注：</span>
          </div>
          <div class="line-info">{{rentMarginInformation.memo || '无'}}</div>
        </div>
      </div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <span class="line-text">费用类型：</span>
          </div>
          <div class="line-info">{{propertyMarginInformation.itemName || '无'}}</div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">金额：</span>
          </div>
          <div class="line-info" v-if="propertyMarginInformation.retreat === '1'">应收{{propertyMarginInformation.itemMoney || '0'}}元</div>
          <div class="line-info" v-if="propertyMarginInformation.retreat === '2'">应退{{propertyMarginInformation.itemMoney || '0'}}元</div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">备注：</span>
          </div>
          <div class="line-info">{{propertyMarginInformation.memo || '无'}}</div>
        </div>
      </div>

      <div class="form-line-title">租金信息</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <span class="line-text">费用类型：</span>
          </div>
          <div class="line-info">{{rentInformation.itemName || '无'}}</div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">金额：</span>
          </div>
          <div class="line-info" v-if="rentInformation.retreat === '1'">应收{{rentInformation.itemMoney || '0'}}元</div>
          <div class="line-info" v-if="rentInformation.retreat === '2'">应退{{rentInformation.itemMoney || '0'}}元</div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">备注：</span>
          </div>
          <div class="line-info">{{rentInformation.memo || '无'}}</div>
        </div>
      </div>

      <div class="form-line-title">物业费信息</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <span class="line-text">费用类型：</span>
          </div>
          <div class="line-info">{{propertyInformation.itemName || '无'}}</div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">金额：</span>
          </div>
          <div class="line-info" v-if="propertyInformation.retreat === '1'">应收{{propertyInformation.itemMoney || '0'}}元</div>
          <div class="line-info" v-if="propertyInformation.retreat === '2'">应退{{propertyInformation.itemMoney || '0'}}元</div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">备注：</span>
          </div>
          <div class="line-info">{{propertyInformation.itemName || '无'}}</div>
        </div>
      </div>

      <div class="form-line-title">其他费用</div>
      <div class="form-line" v-for="(item, index) in otherCostInformation" :key="item.itemName">
        <div>
          <div class="textBox">
            <span class="line-text">费用类型：</span>
          </div>
          <div class="line-info">{{item.itemName || '无'}}</div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">金额：</span>
          </div>
          <div class="line-info" v-if="item.retreat === '1'">应收{{item.itemMoney || '0'}}元</div>
          <div class="line-info" v-if="item.retreat === '2'">应退{{item.itemMoney || '0'}}元</div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">备注：</span>
          </div>
          <div class="line-info">{{item.memo || '无'}}</div>
        </div>
        <!--<div style="margin-left: 20px;display: flex;justify-content: flex-start">-->
          <!--<i class="el-icon-remove-outline" style="line-height: 33px; font-size: 24px; cursor: pointer;margin-right: 20px;color: #f25721;" @click="removeOtherCostInformationLine(index)" v-if="index !== 0"></i>-->
          <!--<i class="el-icon-circle-plus-outline" style="line-height: 33px; font-size: 24px; cursor: pointer;color: #00A0E6;" @click="addOtherCostInformationLine"></i>-->
        <!--</div>-->
      </div>


      <div class="form-title">退租原因</div>
      <div class="form-line discount-line">
        <el-checkbox-group v-model="surrenderReason" size="small" style="width: 100%;display: block;" >
          <div style="width: 90%; padding: 0 40px;margin: 10px 0;display: flex;justify-content: space-between">
            <el-checkbox label="正常到期" disabled border />
            <el-checkbox label="价格因素" disabled border />
            <el-checkbox label="楼宇质量" disabled border />
            <el-checkbox label="卫生环境" disabled border />
            <el-checkbox label="交通不便" disabled border />
          </div>
          <div style="width: 90%; padding: 0 40px;margin: 10px 0;display: flex;justify-content: space-between">
            <el-checkbox label="物业服务" disabled border />
            <el-checkbox label="住户扩张" disabled border />
            <el-checkbox label="经营不善" disabled border />
            <el-checkbox label="设施配置" disabled border />
            <el-checkbox label="周边环境" disabled border />
          </div>
        </el-checkbox-group>
      </div>

      <!--<div class="form-title">备注信息</div>-->
      <div class="form-line">
        <div>
          <div class="textBox">备注：</div>
          <div class="line-info">{{surrenderMemo || '无'}}</div>
        </div>
      </div>


      <!--<div class="form-btn-box">-->
        <!--<button-confirm @confirm="confirm" value="保存" />-->
        <!--<button-confirm-next @confirm="confirmAndApproval" value="保存 & 审批" />-->
        <!--<button-cancel @cancel="cancel" />-->
      <!--</div>-->
    </form>

    <!--<div class="historicalBillDialogBox">-->
      <!--<el-dialog title="历史账单" :visible.sync="historicalBillDialog" width="1300px">-->
        <!--<el-table :data="historicalBillData" style="width: 100%">-->
          <!--<el-table-column prop="enterpriseName" label="住户名称" />-->
          <!--<el-table-column prop="feeType" label="费用类型" />-->
          <!--<el-table-column prop="duration" label="区间" />-->
          <!--<el-table-column prop="payMoney" label="" />-->
          <!--<el-table-column prop="payStatusText" label="缴费状态" />-->
          <!--<el-table-column prop="payTypeText" label="缴费方式" />-->
          <!--<el-table-column prop="payChannelText" label="缴费渠道" />-->
        <!--</el-table>-->
      <!--</el-dialog>-->
    <!--</div>-->


    <el-dialog title="历史账单" :visible.sync="historicalBillDialog" class="detailedDialog" width="1000px">
      <el-tabs v-model="detailedDialogTabs" type="card" >
        <el-tab-pane label="租金明细" name="rent">
          <div v-if="!rentDepositHistoricalBillData && rentHistoricalBillData.length === 0">暂无</div>
          <div v-else style="margin-bottom: 20px">
            <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
              <div style="width: 300px;">区间</div>
              <div style="width: 150px;">费用类型</div>
              <div style="width: 250px;">付款日</div>
              <div style="width: 150px;">缴费状态</div>
              <div style="width: 150px;">应缴金额(元)</div>
            </div>
            <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
              租金保证金
            </div>
            <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
              <div style="width: 300px;overflow: hidden" :title="rentDepositHistoricalBillData.duration">{{rentDepositHistoricalBillData.duration}}</div>
              <div style="width: 150px;overflow: hidden" :title="rentDepositHistoricalBillData.feeType">{{rentDepositHistoricalBillData.feeType}}</div>
              <div style="width: 250px;overflow: hidden" :title="rentDepositHistoricalBillData.payTime">{{rentDepositHistoricalBillData.payTime}}</div>
              <div style="width: 150px;overflow: hidden" :title="rentDepositHistoricalBillData.payStatusText">{{rentDepositHistoricalBillData.payStatusText}}</div>
              <div style="width: 150px;overflow: hidden" :title="rentDepositHistoricalBillData.payMoney">{{rentDepositHistoricalBillData.payMoney || '0'}}元</div>
            </div>
            <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
              租金
            </div>
            <div style="text-align: center;line-height: 36px;">
              <div style="display: flex;justify-content: space-between;" v-for="item in rentHistoricalBillData" :key="item.duration">
                <div style="width: 300px;">{{item.duration}}</div>
                <div style="width: 150px;">{{item.feeType}}</div>
                <div style="width: 250px;">{{item.payTime}}</div>
                <div style="width: 150px;">{{item.payStatusText}}</div>
                <div style="width: 150px;">{{item.payMoney || '0'}}元</div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="物业费明细" name="second">
          <div v-if="!propertyDepositHistoricalBillData && propertyHistoricalBillData.length === 0">暂无</div>
          <div v-else style="margin-bottom: 20px">
            <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
              <div style="width: 300px;">区间</div>
              <div style="width: 150px;">费用类型</div>
              <div style="width: 250px;">付款日</div>
              <div style="width: 150px;">缴费状态</div>
              <div style="width: 150px;">应缴金额(元)</div>
            </div>
            <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
              物业保证金
            </div>
            <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
              <div style="width: 300px;overflow: hidden" :title="propertyDepositHistoricalBillData.duration">{{propertyDepositHistoricalBillData.duration}}</div>
              <div style="width: 150px;overflow: hidden" :title="propertyDepositHistoricalBillData.feeType">{{propertyDepositHistoricalBillData.feeType}}</div>
              <div style="width: 250px;overflow: hidden" :title="propertyDepositHistoricalBillData.payTime">{{propertyDepositHistoricalBillData.payTime}}</div>
              <div style="width: 150px;overflow: hidden" :title="propertyDepositHistoricalBillData.payStatusText">{{propertyDepositHistoricalBillData.payStatusText}}</div>
              <div style="width: 150px;overflow: hidden" :title="propertyDepositHistoricalBillData.payMoney">{{propertyDepositHistoricalBillData.payMoney || '0'}}元</div>
            </div>
            <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
              物业费
            </div>
            <div style="text-align: center;line-height: 36px;">
              <div style="display: flex;justify-content: space-between;" v-for="item in formData.propertyHistoricalBillData">
                <div style="width: 300px;">{{item.duration}}</div>
                <div style="width: 150px;">{{item.feeType}}</div>
                <div style="width: 250px;">{{item.payTime}}</div>
                <div style="width: 150px;">{{item.payStatusText}}</div>
                <div style="width: 150px;">{{item.payMoney || '0'}}元</div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>


    <div class="approveDialogBox">
      <el-dialog title="退租审批" :visible.sync="approveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">
              <b class="red">*</b>
              <span>审批人</span>
            </div>
            <el-select v-model="approveAccountCode" placeholder="请选择" size="mini" style="width: 300px">
              <el-option
                v-for="item in accountList"
                :key="item.code"
                :label="item._labelName"
                :value="item.code">
              </el-option>
            </el-select>
          </div>
          <div class="approveFlexBox">
            <div class="approve_title">退租摘要</div>
            <el-input type="textarea" :rows="4" placeholder="请输入退租摘要" v-model="digest" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="confirmApprove">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {errorHandler} from '../../../utils/errorHandler'
  import {api} from '../../api/InvestmentLeasing'
  import {nError, nSuccess} from '../../../utils/notice'
  import {treeApi} from '../../api/TreeApi'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      InputTree,
      ButtonConfirmNext,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'contract-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧合约',
          name: 'investment-over-view'
        }, {
          value: '归档合同'
        }],
        accountCode: '',
        accountName: '',
        currentCode: '',
        rentWithdrawalCode: '',
        pickerOptions: {
          disabledDate (time) {
            return time.getTime() < Date.now()
          }
        },
        mainTitle: '退租合同',
        subheading: '退租已签约住户的合同信息',
        isHousingInUnion : false,
        secDiscountOrSecIncreaseRate: '1',
        leaseAheadPayDayType: '1',
        secValue: '',
        trdValue: '',
        enterpriseLoading: false,
        enterpriseList: [],
        yqPersonList: [],
        enterpriseCode: '',
        currency: '0',
        currencyList: [{
          code: '0',
          value: '人民币CNY'
        }],
        leaseRentDivideTypeList: [{
          code: '1',
          value: '按起始日划分'
        }, {
          code: '2',
          value: '按自然月划分（首月非整自然月划入第一期）'
        }],
        leasePayUnitTypeList: [{
          code: '1',
          value: '按实际天数计费'
        }, {
          code: '2',
          value: '按月计费'
        }],
        leasePerDayTypeList: [{
          code: '1',
          value: '按自然月换算'
        }, {
          code: '2',
          value: '按年换算'
        }],
        payPeriodList: [
          {
            code: '1',
            value: '1月'
          },
          {
            code: '3',
            value: '3月'
          },
          {
            code: '6',
            value: '6月'
          },
          {
            code: '12',
            value: '12月'
          }
        ],
        propertyDiscountTypeList: [{
          code: '1',
          value: '免租期'
        }],
        incrementalTimePoint: '',
        incrementalTimePointList: [],
        propertyIncrementalTimePointList: [],
        rentDetail: {
          deposit: {},
          detailList: []
        },
        propertyDetail: {
          deposit: {},
          detailList: []
        },
        rentDefaultDetail: {
          deposit: {},
          detailList: []
        },
        propertyDefaultDetail: {
          deposit: {},
          detailList: []
        },
        rentActiveNames: [],
        propertyActiveNames: [],
        rentDetailData: false,
        propertyDetailData: false,
        rentTotal1: 0,
        rentTotal2: 0,
        changeRentData: false,
        propertyTotal1: 0,
        propertyTotal2: 0,
        changePropertyData: false,
        contractManagerIncreaseLeases: [
          {
            leaseIncreaseTimePoint: '',
            leaseIncreasePriceRate: ''
          }
        ],
        contractManagerIncreaseProperties: [
          {
            propertyIncreaseTimePoint: '',
            propertyIncreasePriceRate: ''
          }
        ],
        formData: {
          roomInfoCode: '',          // 房间code
          roomInfoName: '',          // 房间名称
          roomInfoArea: '',           // 房源面积
          officeSeat: '',             // 房间工位
          enterpriseCode: '',        // 住户code
          enterpriseName: '',        // 住户名称
          industry: '',              // 行业分类
          legalPersonName: '',       // 法人姓名
          legalPersonPhone: '',      // 法人联系手机
          signerName: '',            // 签订人姓名
          signerPhone: '',           // 签订人联系手机
          address: '',               // 通讯地址

          contractStartDate: '',     // 合同开始日期
          contractEndDate: '',       // 合同结束日期
          contractSignDate: '',      // 合同签订日期

          leasePledge: '',            // 租金保证金金额
          leaseContractStartDate: '', // 租金开始日期
          leaseContractEndDate: '',   // 租金结束日期
          leaseContractPer: '',       // 合同单价
          leaseContractPerUnit: '1',   // 合同单价单位
          leaseAheadPayDays: '',      // 提前付款天数
          leaseRentDivideType: '1',   // 租期划分方式
          leasePerDayType: '1',        // 天单价换算规则
          leasePayUnitType: '1',      // 计费类型
          daysInYear: '',          // 年天数
          leasePayPeriod: '12',         // 付款周期

          leaseIncreaseTimePoint: '',  // 递增时间点
          leaseIncreasePriceRate: '',  // 单价递增率
          leaseIncreasePriceRateUnitType: '1',  // 单价递增率单位
          leaseIncreaseDepositeRate: '',  // 保证金递增率
          leaseIncreaseDepositeRateUnitType: '1',  // 保证金递增率单位

          leaseDiscountType: '1',        // 优惠类型
          leaseDiscountStartTime: '',   // 折扣起始时间
          leaseDiscountEndTime: '',      // 折扣结束时间
          leaseDiscountMemo: '',         // 折扣备注

          contractManagerIncreaseLeases: [],
          contractManagerIncreaseProperties: [],

          propertyPledge: '',            // 物业费保证金金额
          propertyContractStartDate: '', // 合同开始日期
          propertyContractEndDate: '',   // 合同结束日期
          propertyContractPer: '',       // 合同单价
          propertyContractPerUnit: '1',   // 合同单价单位
          propertyPerDayType: '1',        // 天单价换算规则
          propertyAheadPayDays: '',      // 提前付款天数
          propertyRentDivideType: '1',   // 租期划分方式
          propertyPayUnitType: '1',      // 计费类型
          propertyPayPeriod: '12',         // 付款周期

          propertyIncreaseTimePoint: '',  // 递增时间点
          propertyIncreasePriceRate: '',  // 单价递增率
          propertyIncreasePriceRateUnitType: '1',  // 单价递增率单位
          propertyIncreaseDepositeRate: '',  // 保证金递增率
          propertyIncreaseDepositeRateUnitType: '1',  // 保证金递增率单位

          propertyDiscountType: '1',        // 优惠类型
          propertyDiscountStartTime: '',   // 折扣起始时间
          propertyDiscountEndTime: '',   // 折扣结束时间
          propertyDiscountMemo: '',         // 折扣备注

          fellowPeopleName: '',           // 合同跟进人名称
          fellowPeopleCode: '',           // 合同跟进人code

          leaseContractManagerDetails: [], // 租金明细
          leaseContractManagerDetail: {},  // 租金保证金
          propertyContractManagerDetails: [], // 物业明细
          propertyContractManagerDetail: {},  // 物业保证金
        },
        // 租金保证金信息
        rentMarginInformation: {
          itemName: '租金保证金',
          itemMoney: '0.00',
          retreat: '1',
          memo: ''
        },
        // 物业保证金信息
        propertyMarginInformation: {
          itemName: '物业保证金',
          itemMoney: '0.00',
          retreat: '1',
          memo: ''
        },
        // 租金信息
        rentInformation: {
          itemName: '租金',
          itemMoney: '0.00',
          retreat: '1',
          memo: ''
        },
        // 物业费信息
        propertyInformation: {
          itemName: '物业费',
          itemMoney: '0.00',
          retreat: '1',
          memo: ''
        },
        // 其他费用
        otherCostInformation: [
          {
            itemName: '',
            itemMoney: '0.00',
            retreat: '1',
            memo: ''
          },
        ],
        surrenderDate: '',    // 退租日期
        surrenderReason: [],  // 退租原因
        surrenderMemo: '',    // 备注
        // 历史账单
        historicalBillDialog: false,
        detailedDialogTabs: 'rent',
        historicalBillData: [],
        rentDepositHistoricalBillData: {},
        rentHistoricalBillData: [],
        propertyDepositHistoricalBillData: {},
        propertyHistoricalBillData: [],

        sumMoney: 0.00,
        // 审批信息
        approveDialog: false,
        accountList: [],
        contractCode: '',
        approveAccountCode: '',
        digest: '',
      }
    },
    created () {
      this.accountCode = bus.global.accountCode
      this.accountName = bus.global.accountName
      this.currentCode = this.$route.params.id
      let date = new Date();
      let yy = date.getFullYear()
      let mm = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      let dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.surrenderDate = `${yy}-${mm}-${dd}`
      // this.getAccountListByCode()
      this.getContractByCode()
      this.getListByContractCode()
      this.getSurrenderContractDetailByContractCode()
    },
    methods: {
      toCustomManagement () {
        this.$router.push({
          name: 'contract-management'
        })
      },

      // 查看历史账单
      historyBill () {
        this.historicalBillDialog = true
      },

      // 获取合同信息
      getContractByCode () {
        this.$axios.get(`${api.getContractByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.enterpriseCode = data.enterpriseCode
              data.propertyIncreasePriceRateUnitType = '1'
              data.propertyIncreaseDepositeRateUnitType = '1'
              this.formData = data
            }
          })
          .catch(errorHandler('查询合同失败'))
      },

      // 根据code查历史账单
      getListByContractCode () {
        this.$axios.post(api.getListByContractCode, {
          contractCode: this.currentCode
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              let rentHistoricalBillData = []
              let propertyHistoricalBillData = []
              data.map(v => {
                if (v.payStatus === '0') {
                  v.payStatusText = '未缴费'
                } else if (v.payStatus === '1') {
                  v.payStatusText = '已缴费'
                }
                if (v.feeType === '租金') {
                  rentHistoricalBillData.push(v)
                } else if (v.feeType === '租金保证金') {
                  this.rentDepositHistoricalBillData = v
                } else if (v.feeType === '物业费') {
                  propertyHistoricalBillData.push(v)
                } else if (v.feeType === '物业保证金') {
                  this.propertyDepositHistoricalBillData = v
                }
              })
              this.rentHistoricalBillData = rentHistoricalBillData
              this.propertyHistoricalBillData = propertyHistoricalBillData
              this.historicalBillData = data
            }
          })
          .catch(errorHandler('查询合同失败'))
      },

      // 获取合同退租协议
      getSurrenderContractDetailByContractCode () {
        this.$axios.post(`${api.getSurrenderContractDetailByContractCode}`, {
          contractCode: this.currentCode
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data) {
                this.rentWithdrawalCode = data.code
                this.currentCode = data.currentCode
                this.surrenderMemo = data.surrenderMemo
                this.surrenderDate = data.surrenderDate
                this.surrenderReason = data.surrenderReason.split(',')
                if (data.contractSurrenderDetails) {
                  data.contractSurrenderDetails.map(v => {
                    if (v.itemMoneyReceive) {
                      v.retreat = '1'
                      v.itemMoney = v.itemMoneyReceive
                    } else if (v.itemMoneyBack) {
                      v.retreat = '2'
                      v.itemMoney = v.itemMoneyBack
                    }
                    if (v.itemName === '租金保证金') {
                      this.rentMarginInformation = v
                    } else if (v.itemName === '物业保证金') {
                      this.propertyMarginInformation = v
                    } else if (v.itemName === '租金') {
                      this.rentInformation = v
                    } else if (v.itemName === '物业费') {
                      this.propertyInformation = v
                    } else {
                      this.otherCostInformation.unshift(v)
                    }
                    if (v.payChannel === '1') {
                      v.payChannelText = '支付宝'
                    } else if (v.payChannel === '2') {
                      v.payChannelText = '微信'
                    } else if (v.payChannel === '3') {
                      v.payChannelText = '银行转账'
                    } else if (v.payChannel === '4') {
                      v.payChannelText = '现金'
                    } else if (v.payChannel === '5') {
                      v.payChannelText = '其他'
                    } else {
                      v.payChannelText = '--'
                    }
                    if (v.payType === '1') {
                      v.payTypeText = '月缴'
                    } else if (v.payType === '2') {
                      v.payTypeText = '季缴'
                    } else if (v.payType === '3') {
                      v.payTypeText = '半年缴'
                    } else if (v.payType === '4') {
                      v.payTypeText = '年缴'
                    } else {
                      v.payTypeText = '--'
                    }
                  })
                  if (this.otherCostInformation.length > 1) {
                    this.otherCostInformation.pop()
                  }
                  this.allMoneyToFixed2(data.contractSurrenderDetails)
                }
              }
            }
          })
          .catch(errorHandler('查询合同退租协议失败'))
      },

      // 所有金额保留两位小数并计算应收应退
      allMoneyToFixed2 (contractSurrenderDetails) {
        let sumMoney = 0.00
        contractSurrenderDetails.map(contractSurrenderDetail => {
          if (contractSurrenderDetail.itemMoneyReceive) {
            sumMoney = sumMoney + parseFloat(contractSurrenderDetail.itemMoneyReceive)
          } else {
            sumMoney = sumMoney - parseFloat(contractSurrenderDetail.itemMoneyBack)
          }
        })
        this.sumMoney = sumMoney.toFixed(2)
      },

      // 获取审批人员列表
      getAccountListByCode () {
        this.$axios.post(api.getAccountListByCode, {
          accountCode: this.accountCode
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data.length > 0) {
                data.map(v => {
                  v._labelName = `${v.name} / ${v.actualName}`
                })
              }
              this.accountList = data
            }
          })
          .catch(errorHandler('获取审批人员列表失败'))
      },

      cancel () {
        this.toCustomManagement()
      },

    }
  }
</script>

<style scoped>
  form {
    width: 1200px;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-title {
    color: #333333;
    font-size: 16px;
    line-height: 28px;
    padding-left: 5px;
    margin-top: 5px;
    border-left: 3px solid #00a0e6;
  }
  .form-line-title {
    font-size: 14px;
    line-height: 28px;
    padding-left: 40px;
  }
  .form-line {
    margin: 5px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 35px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
  }
  .line-info {
    width: 220px;
  }
  .textBox {
    display: inline-block;
    width: 130px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    margin: 30px auto;
    display: flex;
    justify-content: flex-end;
    text-align: right;
  }
</style>

<style lang="less">
  .contractAdd {
    .el-input--mini {
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
  }

  .historicalBillDialogBox {
    .el-dialog .el-dialog__body .el-table th:first-child {
      width: auto;
    }
  }

  .el-checkbox.is-bordered.el-checkbox--small {
    min-width: 100px;
  }

  .el-select .el-input .el-select__caret {
    height: 32px;
  }
  .el-input-group__append {
    padding: 0 5px!important;
    width: auto!important;
  }
  .el-input-group__prepend {
    padding: 0 5px!important;
    width: auto!important;
  }
  .discount-line {
    .el-input-group__append, .el-input-group__prepend {
      padding: 0 20px!important;
    }
  }

  //.el-tabs__content {
  //  .textBox {
  //    width: 120px;
  //  }
  //}

  .el-collapse-item__arrow {
    line-height: 48px!important;
  }

  .contractAdd {
    .el-input__inner {
      padding: 0 0 0 15px;
    }
    .el-input--prefix .el-input__inner {
      padding: 0 0 0 30px;
    }
  }

  .contractAdd {
    .el-input-group--prepend {
      .el-input__inner {
        padding: 0 0 0 25px;
      }
      .el-input__suffix {
        right: 15px;
      }
    }
  }
  .historicalBillDialogBox {
    .el-table thead {
      color: #48576a;
    }
    .el-table::before {
      height: 0;
    }
    .el-table .el-table__header tr {
      background-color: #eff1f5;
      th {
        background-color: #eff1f5;
      }
    }
    .el-table .cell {
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .el-button--text {
      color: #00A0E6;
      font-size: 14px;
      :hover {
        color: #06b3ff;
      }
    }
    .el-table td {
      padding: 8px 0;
    }
    tbody {
      overflow: scroll;
    }
    .el-pagination {
      margin-top: 15px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/ContractManagement/FilingRentWithdrawalDetail.vue